import React, { useState, useCallback, useEffect } from 'react';
import axios from "axios";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Modal, Tab, Tabs, Button, Dropdown, DropdownButton } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getCareNavigators, fetchWorkingPlansAndBreaks, saveAppointmentSlots } from "../../../services/medengage/Service";
import { formatDateWithOrdinal } from '../../cn/components/common/Utils';
import alertify from 'alertifyjs';
import './CNWorkingPlans.css'
import moment from 'moment';
import { LoaderLoader } from '../../utils/CommonLibrary';
import CNAddSlots from './CNAddSlots';

const CNWorkingPlans = () => {
    const [loading, setLoading] = useState(false);
    const [breakDate, setBreakDate] = useState(null);
    const [breakStartTime, setBreakStartTime] = useState(null);
    const [breakEndTime, setBreakEndTime] = useState(null);
    const [breakReasonStr, setBreakReasonStr] = useState('');
    const [workingPlansAndBreaksInfo, setWorkingPlansAndBreaksInfo] = useState([]);
    const [upcomingBreaks, setUpcomingBreaks] = useState([]);
    const [pastBreaks, setPastBreaks] = useState([]);
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [origSelectedSlots, setOrigSelectedSlots] = useState([]);
    const [selectedDay, setSelectedDay] = useState("Monday");
    const [copyFrom, setCopyFrom] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [breakMessage, setBreakMessage] = useState("");
    const [breakError, setBreakError] = useState("");
    const [breakEditError, setBreakEditError] = useState("");
    const [breakEditEndTime, setBreakEditEndTime] = useState({ breakId: '', breakEndTime: null });
    const [breakReasonsList, setBreakReasonsList] = useState([]);

    const [carenavigatorsList, setCarenavigatorsList] = useState([]);
    const [cnId, setCnId] = useState("");

    const currentTime = new Date();
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0);

    const slotValidityText = "These slots are valid from " + formatDateWithOrdinal(today) + " till " + formatDateWithOrdinal(nextMonth);

    const slotDuration = 10;
    const timesInADay = 4; //morning, afternoon, evening and night
    const hoursInADay = 24;
    const slotsInaColumn = ((60 / slotDuration) * (hoursInADay / timesInADay)) / 2; //(minutes in one hour / slotDuration) ((minutes in one hour / slotDuration)* hours in one times of the day(morning, afternoon, evening, night))/2;
    const differentInMinutesBetweenSlotsinOneColumn = slotDuration * 2;


    useEffect(() => {
        getCareNavigatorsList();
    }, []);

    const getCareNavigatorsList = async () => {
        await getCareNavigators()
            .then((response) => {
                if (response.data.code === 200) {
                    const carenavigators = response.data.data.users;
                    setCarenavigatorsList(carenavigators);
                }
            }).catch(function (error) {
                console.log(error);
            });
    };

    const getWorkingPlansAndBreaks = async (cnId) => {
        setLoading(true);
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchWorkingPlansAndBreaks(cnId, ct)
            .then((response) => {
                if (response.data.code === 200) {
                    setWorkingPlansAndBreaksInfo(response.data.data);
                    setSelectedSlots(response.data.data.daywiseselectedslots);
                    setOrigSelectedSlots(response.data.data.daywiseselectedslots);
                }
                setLoading(false);
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleSlotClick = (day, time) => {
        setSelectedSlots(prevState => {
            const daySlots = prevState[day];
            const updatedDaySlots = daySlots.includes(time) ? daySlots.filter(slot => slot !== time) : [...daySlots, time];
            return {
                ...prevState, [day]: updatedDaySlots
            };
        });
    };

    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const TimeCapsule = ({ startTime, day }) => {
        const times = [];
        for (let i = 0; i < slotsInaColumn; i++) {
            const time1 = new Date(startTime.getTime() + i * differentInMinutesBetweenSlotsinOneColumn * 60000); // 1-hour interval for the first sub-column
            const timeString = time1.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();
            times.push(
                <div key={i} className={`${day} d-flex time-capsule ${selectedSlots[day] && selectedSlots[day].includes(timeString) ? 'selectedSlot' : ''}`} onClick={() => handleSlotClick(day, timeString)}>
                    <div className="flex-fill">{timeString} </div>
                </div>
            );
        }
        return <div>{times}</div>;
    };

    const DayColumn = ({ startTime, day }) => (
        <div className="d-flex" style={{ justifyContent: 'center' }}>
            <div className="flex-column">
                <TimeCapsule startTime={startTime} day={day} />
            </div>
            <div className="flex-column pad-left">
                <TimeCapsule startTime={new Date(startTime.getTime() + slotDuration * 60000)} day={day} />
            </div>
        </div>
    );

    const handleCopyFrom = (e) => {
        const { options, selectedIndex } = e.target;
        const cf = options[selectedIndex].text;
        setCopyFrom(cf);
    }

    const handleCopy = () => {
        if (copyFrom != "") {
            setSelectedSlots(selectedSlots => ({
                ...selectedSlots,
                [selectedDay]: selectedSlots[copyFrom]
            }));
            setCopyFrom("");
        }

    }

    const handleDayChange = (day) => {
        setSelectedDay(day)
    }

    const handleWPSave = async () => {
        setError("");
        setMessage("");
        if (selectedSlots[selectedDay].length <= 0) {
            setError("No slot is selected");
        } else {
            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            await saveAppointmentSlots(cnId, selectedDay, selectedSlots[selectedDay], selectedSlots[selectedDay].length, ct)
                .then((response) => {
                    if (response.data.code === 200) {
                        getWorkingPlansAndBreaks(cnId);
                        setMessage(response.data.data.message);
                    } else {
                        setError(response.data.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }
    const WorkingPlans = () => {
        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        const columns = ['Night', 'Morning', 'Afternoon', 'Evening'];
        const startTimes = [
            new Date('1970-01-01T00:00:00'),
            new Date('1970-01-01T06:00:00'),
            new Date('1970-01-01T12:00:00'),
            new Date('1970-01-01T18:00:00'),
        ];

        return (
            <div className='WorkingPlansTab '>
                <div className="container-fluid">
                    <div className="row align-items-center mb-3">
                        <div className='col-md-4 me-2 pe-2'>
                            <select name="cnId" value={cnId} className='form-select input-field-ui' onChange={(e) => {
                                setCnId(e.target.value);
                                getWorkingPlansAndBreaks(e.target.value)
                            }}>
                                <option value="">Select Care Navigator</option>
                                {
                                    carenavigatorsList.map((item, index) => {
                                        return <option key={index} value={item.id}>{item.userName}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col pb-0">
                            <p>This will be set as the CareNavigator's availability for every day of the week (every Monday, Tuesday..... Sunday). The slots are displayed as per your time-zone.
                            </p>
                        </div>
                    </div>
                </div>
                {
                    cnId != "" &&
                    <>
                        <div className="container-fluid">
                            <div className="row align-items-center mb-3">

                                <div className='col'>
                                    <CNAddSlots getWorkingPlansAndBreaks={getWorkingPlansAndBreaks} cnId={cnId} slotDuration={slotDuration} origSelectedSlots={origSelectedSlots} />
                                </div>
                            </div>
                            <div className="col-12 px-0 mt-1"><hr /></div>
                            <div className={`${error != "" ? "errorDiv" : "hide"}`}>{error}</div>
                            <div className={`${message != "" ? "messageDiv" : "hide"}`}>{message}</div>
                            <Tabs activeKey={selectedDay} defaultActiveKey={selectedDay} onSelect={handleDayChange} className='TabCNWorkingPlans'>
                                {days.map((day) => (
                                    <Tab eventKey={day} title={day} key={day}>
                                        <div className="d-flex">
                                            {columns.map((col, index) => (
                                                <div className="p-2 flex-fill" key={col}>
                                                    <h5 className='day-hour-h5'>{col}</h5>
                                                    <DayColumn startTime={startTimes[index]} day={day} />
                                                </div>
                                            ))}
                                        </div>
                                    </Tab>
                                ))}
                            </Tabs>
                            <br />
                            <Row>
                                <Col className='copy-cell'>
                                    <select className='form-select control-input-uibox' value={copyFrom} onChange={(e) => handleCopyFrom(e)}>
                                        <option value="">Same as</option>
                                        {days.map((day, index) => (
                                            <option value={day} key={index}>{day}</option>
                                        ))}
                                    </select>
                                    <Button variant="primary" className='copy-save-btn' onClick={() => handleCopy()}>
                                        Copy
                                    </Button>
                                </Col>
                                <Col className='align-right'>
                                    <Button className='mx-2 close-reset-btn' variant="warning" onClick={() => setSelectedSlots(origSelectedSlots)}>Reset</Button>
                                    <Button variant="primary" className='copy-save-btn' onClick={handleWPSave}>Save for {selectedDay}</Button>
                                </Col>
                            </Row>
                        </div>
                    </>
                }

            </div>
        );
    };

    return (
        <>
            <LoaderLoader isLoading={loading} />
            <WorkingPlans />
        </>
    );
}

export default CNWorkingPlans